// Ícone pulsante laranja
const PulsarIcon = () => (
  <span style={{
    display: 'inline-block',
    width: 18,
    height: 18,
    borderRadius: '50%',
    background: '#ff9800',
    boxShadow: '0 0 0 0 #ff9800',
    animation: 'pulseOrange 1.2s infinite',
    marginRight: 8,
    verticalAlign: 'middle',
  }} />
);

// Adiciona a animação globalmente
const style = document.createElement('style');
style.innerHTML = `
@keyframes pulseOrange {
  0% { box-shadow: 0 0 0 0 #ff980080; }
  70% { box-shadow: 0 0 0 10px #ff980000; }
  100% { box-shadow: 0 0 0 0 #ff980000; }
}`;
document.head.appendChild(style);
import React, { useState, useContext } from "react";
import ReactDOM from "react-dom";
import { OperacaoContext } from "../../../context/OperacaoContext";
import { useNavigate } from "react-router-dom";
import { FaUser, FaBullhorn, FaCalendarPlus, FaPlay, FaClock, FaCheckCircle, FaHourglassEnd, FaCheck, FaTimesCircle, FaExclamationTriangle } from "react-icons/fa";
import LogoCompleta from "../../../assets/logonotify1.png";
import LogoIcone from "../../../assets/notifyicone.png";
import './Operacoes.css';

const HEADER_HEIGHT = 56;

const TABS = [
  { key: "geral", label: "Geral" },
  { key: "espera", label: "Espera" },
  { key: "agendado", label: "Agendado" },
  { key: "processo", label: "Processo" },
  { key: "sucesso", label: "Sucesso" },
  { key: "falhou", label: "Falhou" },
];

const Operacoes = () => {

        const [modalExcluir, setModalExcluir] = useState({ aberto: false, idx: null });
        // Estado para controlar o modal de erro
        const [modalErro, setModalErro] = useState({ aberto: false, idx: null });

        function handleExcluirConfirmado() {
          setOperacoes(ops => ops.filter((_, i) => i !== modalExcluir.idx));
          setModalExcluir({ aberto: false, idx: null });
        }

      // Armazena os intervalos de envio para poder cancelar
      const envioIntervals = React.useRef({});
      const [enviando, setEnviando] = useState({}); // { idx: { tempo, enviadas, total, cancelado } }

      // Função para simular envio
      function handleEnviarAgora(idx, total) {
        setEnviando(prev => ({
          ...prev,
          [idx]: { tempo: 0, enviadas: 0, total, erro: false, cancelado: false }
        }));
        let count = 0;
        // Aumenta o tempo de disparo para 7 segundos por mensagem
        const interval = setInterval(() => {
          setEnviando(prev => {
            const atual = prev[idx] || { tempo: 0, enviadas: 0, total, erro: false, cancelado: false };
            if (atual.cancelado) {
              clearInterval(interval);
              return prev;
            }
            // Simula erro na última mensagem (exemplo)
            const erro = atual.enviadas + 1 === atual.total && Math.random() < 0.5;
            if (atual.enviadas + 1 >= total) {
              clearInterval(interval);
              setTimeout(() => setEnviando(p => { const c = { ...p }; delete c[idx]; return c; }), 1000);
              setOperacoes(ops => {
                const novas = [...ops];
                if (novas[idx]) {
                  novas[idx].status = erro ? 'Falhou' : 'Enviado';
                  const agora = new Date();
                  const hora = agora.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                  novas[idx].horaDisparo = hora;
                  if (erro) novas[idx].erroEnvio = true;
                }
                return novas;
              });
            }
            return {
              ...prev,
              [idx]: {
                tempo: atual.tempo + 1,
                enviadas: Math.min(atual.enviadas + 1, total),
                total,
                erro,
                cancelado: false
              }
            };
          });
        }, 9000);
        envioIntervals.current[idx] = interval;
      }

      // Função para cancelar envio imediatamente
      function handleCancelarEnvio(idx) {
        setEnviando(prev => ({
          ...prev,
          [idx]: prev[idx] ? { ...prev[idx], cancelado: true } : { cancelado: true }
        }));
        if (envioIntervals.current[idx]) {
          clearInterval(envioIntervals.current[idx]);
          delete envioIntervals.current[idx];
        }
        setOperacoes(ops => {
          const novas = [...ops];
          if (novas[idx]) {
            novas[idx].status = 'Cancelado';
          }
          return novas;
        });
      }

      // Estado para controlar reprocessamento e modal
      const [reprocessando, setReprocessando] = useState({}); // { idx: true }
      const [modalReprocessar, setModalReprocessar] = useState({ aberto: false, idx: null, sucesso: [], falha: [] });

      function handleReprocessar(idx) {
        setReprocessando(prev => ({ ...prev, [idx]: true }));
        setOperacoes(ops => {
          const novas = [...ops];
          if (novas[idx]) {
            novas[idx].status = 'Agendado';
            novas[idx].erroEnvio = false;
            novas[idx].horaDisparo = null;
          }
          return novas;
        });
        // Simula reprocessamento (substitua pela lógica real)
        const mensagens = operacoes[idx]?.mensagens || [];
        setTimeout(() => {
          // Simula resultado: metade sucesso, metade falha
          const sucesso = mensagens.filter((_, i) => i % 2 === 0);
          const falha = mensagens.filter((_, i) => i % 2 !== 0);
          setModalReprocessar({ aberto: true, idx, sucesso, falha });
          setReprocessando(prev => {
            const novo = { ...prev };
            delete novo[idx];
            return novo;
          });
        }, 2000);
        // Reinicia o envio das mensagens
        const total = mensagens.length || 5;
        handleEnviarAgora(idx, total);
      }
    const [menuAberto, setMenuAberto] = useState(null); // Para controlar qual menu está aberto

    // Fecha o menu ao clicar fora
    React.useEffect(() => {
      function handleClick() {
        setMenuAberto(null);
      }
      if (menuAberto !== null) {
        document.addEventListener('click', handleClick);
        return () => document.removeEventListener('click', handleClick);
      }
    }, [menuAberto]);
  const { operacoes, setOperacoes } = useContext(OperacaoContext);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("geral");
  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");
  const navigate = useNavigate(); // Adicionado para navegação

  // Conteúdo de cada aba (exemplo, personalize conforme necessário)
  const tabContent = {
    geral: (
      <>
        <div>
          <div style={{ display: "flex", gap: 16, marginBottom: 24 }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label style={{ fontWeight: "bold", color: "#005c53", marginBottom: 4 }}>Início</label>
              <input
                type="date"
                value={dataInicio}
                onChange={e => setDataInicio(e.target.value)}
                style={{
                  padding: "8px 12px",
                  borderRadius: 8,
                  border: "1px solid #51a197",
                  fontSize: 15,
                  color: "#005c53",
                  minWidth: 140
                }}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label style={{ fontWeight: "bold", color: "#005c53", marginBottom: 4 }}>Fim</label>
              <input
                type="date"
                value={dataFim}
                onChange={e => setDataFim(e.target.value)}
                style={{
                  padding: "8px 12px",
                  borderRadius: 8,
                  border: "1px solid #51a197",
                  fontSize: 15,
                  color: "#005c53",
                  minWidth: 140
                }}
              />
            </div>
          </div>
          <strong><div>Informações Gerais das Operações</div></strong>
        </div>
        {/* Container das operações - APENAS NA ABA GERAL */}
        <div style={{ display: "flex", flexDirection: "column", margin: "24px 0", width: "100%", maxWidth: 900 }}>
          {operacoes && operacoes.length > 0 ? (
            operacoes.map((op, idx) => (
              <div key={idx} style={{
                display: "flex",
                flexDirection: "column",
                border: "1px solid #ccc",
                borderRadius: "8px",
                overflow: "hidden",
                marginBottom: 32,
                background: "#fff",
                position: 'relative'
              }}>
                {/* Título do tipo de operação */}
                <div style={{
                  background: reprocessando[idx] ? '#fff' : (op.status === 'Agendado' ? '#ff9800' : '#51a197'),
                  color: reprocessando[idx] ? '#e74c3c' : '#fff',
                  border: reprocessando[idx] ? '2px solid #e74c3c' : undefined,
                  padding: '10px 24px',
                  fontWeight: 'bold',
                  fontSize: 17,
                  borderTopLeftRadius: 8,
                  borderTopRightRadius: 8,
                  letterSpacing: 0.5,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10
                }}>
                    {reprocessando[idx]
                      ? 'Reprocessando...'
                      : (op.tipo && op.tipo.toLowerCase() === 'adicionar administrador' && op.status === 'Agendado')
                        ? 'Operação de Adicionar Administrador Agendada'
                        : (op.tipo && op.tipo.toLowerCase() === 'remover administrador' && op.status === 'Agendado')
                          ? 'Operação de Remover Administrador Agendada'
                        : (op.tipo && (op.tipo.toLowerCase() === 'mover campanha' || op.tipo.toLowerCase() === 'movecamp' || op.tipo.toLowerCase() === 'movercampanha') && op.status === 'Agendado')
                          ? 'Operação de Mover Campanha Agendada'
                        : (op.tipo && (op.tipo.toLowerCase() === 'muda nome' || op.tipo.toLowerCase() === 'mudar nome') && op.status === 'Agendado')
                          ? 'Operação de Mudar Nome Agendada'
                        : (op.tipo && (op.tipo.toLowerCase() === 'mudar imagem' || op.tipo.toLowerCase() === 'muda imagem') && op.status === 'Agendado')
                          ? 'Operação de Mudar Imagem Agendada'
                        : (op.status === 'Agendado' && op.tipo && (op.tipo.toLowerCase().includes('config')))
                          ? 'Operação de Mudar Configuração Agendada'
                        : (op.status === 'Enviado' && op.tipo && (op.tipo.toLowerCase().includes('config')))
                          ? 'Operação de Mudar Configuração Enviada'
                        : (op.status === 'Agendado' && op.tipo)
                          ? `Operação de ${op.tipo} Agendada`
                        : `Operação de ${op.tipo || 'Mensagem'} ${op.status === 'Agendado' ? 'Agendada' : 'Enviada'}`}
                    {/* Ícone de alerta se houver erro */}
                    {(op.status === 'Falhou' || op.erroEnvio) && (
                      <span style={{ marginLeft: 10, display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                        onClick={() => setModalErro({ aberto: true, idx })}
                      >
                        <FaExclamationTriangle color="#e74c3c" size={22} title="Clique para ver detalhes do erro" />
                      </span>
                    )}
                        {/* Modal de erro global, fora do map */}
                        {modalErro.aberto && (
                          <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.35)', zIndex: 999999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <div style={{ background: '#fff', borderRadius: 12, padding: 32, minWidth: 340, boxShadow: '0 4px 32px rgba(0,0,0,0.18)' }}>
                              <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 18, color: '#e74c3c', display: 'flex', alignItems: 'center', gap: 10 }}>
                                <FaExclamationTriangle color="#e74c3c" size={22} /> Erro no envio da operação
                              </div>
                              <div style={{ marginBottom: 18, fontSize: 16, color: '#222' }}>
                                {operacoes[modalErro.idx]?.erroEnvioMsg || 'Ocorreu um erro ao enviar uma ou mais mensagens para os grupos. Verifique a conexão, permissões ou tente novamente.'}
                              </div>
                              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <button onClick={() => setModalErro({ aberto: false, idx: null })} style={{ padding: '8px 24px', borderRadius: 8, border: 'none', background: '#51a197', color: '#fff', fontWeight: 600, cursor: 'pointer' }}>Fechar</button>
                              </div>
                            </div>
                          </div>
                        )}
                  {(enviando[idx] || (op.status === 'Enviado' || op.status === 'Falhou' || op.status === 'Cancelado')) && (
                    <span style={{ marginLeft: 12, display: 'flex', alignItems: 'center', gap: 10 }}>
                      <FaClock color={reprocessando[idx] ? '#e74c3c' : '#fff'} size={18} className="spin" />
                      <span style={{ fontWeight: 600, fontSize: 15 }}>
                        {enviando[idx]?.tempo ? enviando[idx].tempo + 's' : ''}
                      </span>
                      <span style={{ background: '#2ecc40', color: '#fff', borderRadius: 12, padding: '2px 10px', marginLeft: 6, fontWeight: 600, fontSize: 15 }}>
                        {(enviando[idx]?.enviadas ?? op.mensagens?.length ?? 0)}/{enviando[idx]?.total ?? op.mensagens?.length ?? 0} enviadas
                      </span>
                      <span style={{ fontWeight: 600, fontSize: 15, color: reprocessando[idx] ? '#e74c3c' : '#fff', marginLeft: 6 }}>
                        {Math.round(((enviando[idx]?.enviadas ?? op.mensagens?.length ?? 0) / (enviando[idx]?.total ?? op.mensagens?.length ?? 1)) * 100)}%
                      </span>
                      <span style={{ width: 80, height: 10, background: '#fff', borderRadius: 6, overflow: 'hidden', marginLeft: 8, border: '1px solid #2ecc40', display: 'flex', alignItems: 'center' }}>
                        <span style={{ display: 'block', height: '100%', background: '#2ecc40', width: `${((enviando[idx]?.enviadas ?? op.mensagens?.length ?? 0) / (enviando[idx]?.total ?? op.mensagens?.length ?? 1)) * 100}%`, transition: 'width 0.3s' }}></span>
                      </span>
                      {enviando[idx]?.erro && (
                        <FaTimesCircle color="#e74c3c" size={20} title="Erro ao enviar mensagem" />
                      )}
                    </span>
                  )}
                                  {/* Modal de resultado do reprocessamento */}
                                  {modalReprocessar.aberto && modalReprocessar.idx === idx && (
                                    <div style={{
                                      position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.35)', zIndex: 999999,
                                      display: 'flex', alignItems: 'center', justifyContent: 'center'
                                    }}>
                                      <div style={{ background: '#fff', borderRadius: 12, padding: 32, minWidth: 340, boxShadow: '0 4px 32px rgba(0,0,0,0.18)' }}>
                                        <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 18, color: '#e74c3c' }}>Resultado do Reprocessamento</div>
                                        <div style={{ marginBottom: 12, fontSize: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
                                          <FaBullhorn color="#005c53" size={18} />
                                          <b>Total de mensagens disparadas:</b> {modalReprocessar.sucesso.length + modalReprocessar.falha.length}
                                        </div>
                                        <div style={{ marginBottom: 12, fontSize: 16, color: '#27ae60', display: 'flex', alignItems: 'center', gap: 8 }}>
                                          <FaCheckCircle color="#27ae60" size={18} />
                                          <b>Enviadas com sucesso:</b> {modalReprocessar.sucesso.length}
                                        </div>
                                        <div style={{ marginBottom: 18, fontSize: 16, color: '#e74c3c', display: 'flex', alignItems: 'center', gap: 8 }}>
                                          <FaTimesCircle color="#e74c3c" size={18} />
                                          <b>Com erro:</b> {modalReprocessar.falha.length}
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                          <button onClick={() => setModalReprocessar({ aberto: false, idx: null, sucesso: [], falha: [] })} style={{ padding: '8px 24px', borderRadius: 8, border: 'none', background: '#51a197', color: '#fff', fontWeight: 600, cursor: 'pointer' }}>Fechar</button>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                  <span
                    style={{ marginLeft: 'auto', cursor: 'pointer', fontSize: 22, color: '#fff' }}
                    title="Mais opções"
                    onClick={e => {
                      e.stopPropagation();
                      setMenuAberto(menuAberto === idx ? null : idx);
                    }}
                  >&#8942;</span>
                  {menuAberto === idx && typeof window !== 'undefined' && (() => {
                    // Pega a posição do botão dos 3 pontinhos
                    const el = document.querySelectorAll('[title="Mais opções"]')[idx];
                    let top = 100, left = 100;
                    if (el) {
                      const rect = el.getBoundingClientRect();
                      top = rect.top + window.scrollY - 8; // um pouco acima
                      left = rect.right + window.scrollX - 180; // alinhado à direita
                    }
                    return ReactDOM.createPortal(
                      <div
                        style={{
                          position: 'absolute',
                          top,
                          left,
                          background: '#fff',
                          border: '1px solid #e0e0e0',
                          borderRadius: 8,
                          boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                          zIndex: 99999,
                          minWidth: 160,
                          padding: '6px 0',
                        }}
                      >
                        {op.status === 'Agendado' && (
                          <>
                            <div style={{ padding: '8px 18px', cursor: 'pointer', color: '#2980b9', fontWeight: 500 }} onClick={e => { e.stopPropagation(); setMenuAberto(null); handleEnviarAgora(idx, op.mensagens?.length || 5); }}>Enviar agora</div>
                            <div style={{ padding: '8px 18px', cursor: 'pointer', color: '#f39c12', fontWeight: 500 }} onClick={e => {
                              e.stopPropagation();
                              setMenuAberto(null);
                              // Detecta tipo de operação e, se for agendada, inicia o fluxo na etapa correta
                              const tipo = (op && op.tipo) ? String(op.tipo).toLowerCase() : '';
                                                                                          const isMoverCamp = tipo.includes('mover campanha') || tipo.includes('movecamp') || tipo.includes('movercampanha');
                                                            const isRemoverUser = tipo.includes('remover participante') || tipo.includes('remover user') || tipo.includes('removerusuario') || tipo.includes('remover usuário') || tipo.includes('remuser');
                              const isMudarNome = tipo.includes('mudar nome') || tipo.includes('muda nome') || (tipo.includes('mudar') && tipo.includes('nome')) || tipo.includes('mudarnome');
                              const isMudarDescricao = tipo.includes('mudar descr') || tipo.includes('muda descr') || tipo.includes('descricao') || tipo.includes('descrição') || tipo.includes('mudar descrição');
                              const isMudarImagem = tipo.includes('imagem') || tipo.includes('mudar imagem') || tipo.includes('muda imagem') || tipo.includes('mudar foto') || tipo.includes('foto');
                              const isMudarConfig = tipo.includes('config') || tipo.includes('configur') || tipo.includes('configuração') || tipo.includes('configuracao') || tipo.includes('mudar config') || tipo.includes('mudar configuração');
                              const isAdicionarAdm = tipo.includes('adicionar adm') || tipo.includes('adicionar administrador') || tipo.includes('adiciona adm');
                              const isRemoverAdm = tipo.includes('remover adm') || tipo.includes('remover administrador') || tipo.includes('remove adm');
                              if (op.status === 'Agendado') {
                                if (isMudarNome) {
                                  navigate('/Adicionaroperacao', { state: { editar: true, idx, etapa: 1, selected: 'nome' } });
                                } else if (isMudarDescricao) {
                                  navigate('/Adicionaroperacao', { state: { editar: true, idx, etapa: 1, selected: 'descricao' } });
                                } else if (isMudarImagem) {
                                  navigate('/Adicionaroperacao', { state: { editar: true, idx, etapa: 1, selected: 'imagem' } });
                                } else if (isMudarConfig) {
                                  navigate('/Adicionaroperacao', { state: { editar: true, idx, etapa: 1, selected: 'config' } });
                                } else if (isAdicionarAdm) {
                                  navigate('/Adicionaroperacao', { state: { editar: true, idx, etapa: 1, selected: 'addadmin' } });
                                } else if (isRemoverAdm) {
                                  navigate('/Adicionaroperacao', { state: { editar: true, idx, etapa: 1, selected: 'remadmin' } });
                                } else if (isRemoverUser) {
                                  navigate('/Adicionaroperacao', { state: { editar: true, idx, etapa: 1, selected: 'remuser' } });
                                } else if (isMoverCamp) {
                                  navigate('/Adicionaroperacao', { state: { editar: true, idx, etapa: 1, selected: 'movecamp' } });
                                } else {
                                  navigate('/Adicionaroperacao', { state: { editar: true, idx, etapa: 1 } });
                                }
                              } else {
                                navigate('/Adicionaroperacao', { state: { editar: true, idx, etapa: 1 } });
                              }
                            }}>Editar</div>
                          </>
                        )}
                        <div style={{ padding: '8px 18px', cursor: 'pointer', color: '#005c53', fontWeight: 500 }} onClick={e => { e.stopPropagation(); setMenuAberto(null); handleReprocessar(idx); }}>Reprocessar</div>
                        <div style={{ padding: '8px 18px', cursor: 'pointer', color: '#e67e22', fontWeight: 500 }} onClick={e => { e.stopPropagation(); setMenuAberto(null); handleCancelarEnvio(idx); }}>Cancelar</div>
                        <div style={{ padding: '8px 18px', cursor: 'pointer', color: '#e74c3c', fontWeight: 500 }} onClick={e => { e.stopPropagation(); setMenuAberto(null); setModalExcluir({ aberto: true, idx }); }}>Excluir</div>
                            {/* Modal de confirmação de exclusão */}
                            {modalExcluir.aberto && (
                              <div style={{
                                position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.35)', zIndex: 999999,
                                display: 'flex', alignItems: 'center', justifyContent: 'center'
                              }}>
                                <div style={{ background: '#fff', borderRadius: 12, padding: 32, minWidth: 320, boxShadow: '0 4px 32px rgba(0,0,0,0.18)' }}>
                                  <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 18 }}>Deseja realmente excluir esta operação?</div>
                                  <div style={{ display: 'flex', gap: 16, justifyContent: 'flex-end' }}>
                                    <button onClick={() => setModalExcluir({ aberto: false, idx: null })} style={{ padding: '8px 24px', borderRadius: 8, border: 'none', background: '#ccc', color: '#222', fontWeight: 500, cursor: 'pointer' }}>Não</button>
                                    <button onClick={handleExcluirConfirmado} style={{ padding: '8px 24px', borderRadius: 8, border: 'none', background: '#e74c3c', color: '#fff', fontWeight: 600, cursor: 'pointer' }}>Sim, excluir</button>
                                  </div>
                                </div>
                              </div>
                            )}
                      </div>,
                      document.body
                    );
                  })()}
                </div>
                <div style={{ display: 'flex', flex: 1, minHeight: 320 }}>
                {/* Lado direito: Informações adicionais */}
                {/* Lado esquerdo: Mensagens */}
                  <div
                    style={{
                      flex: 1,
                      backgroundImage: `url(${require('../../../assets/whatsapp-bg.png')})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      padding: "16px",
                      overflowY: "auto",
                      maxHeight: '350px', // Altura máxima fixa para rolar
                      minHeight: '120px',
                      borderRadius: '12px',
                      border: '1px solid #e0e0e0',
                    }}
                  >
                  {op.novoNome ? (
                    <div style={{
                      maxWidth: '95%',
                      background: '#dcf8c6',
                      color: '#222',
                      borderRadius: '16px 16px 4px 16px',
                      padding: '10px 16px',
                      marginBottom: '12px',
                      boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                      fontSize: 15,
                      alignSelf: 'flex-end',
                      border: '1px solid #b2e59e',
                      wordBreak: 'break-word',
                    }}>
                      <span dangerouslySetInnerHTML={{ __html: formatMessage(String(op.novoNome)) }} />
                    </div>
                  ) : (op.mensagens && op.mensagens.length > 0 ? (
                    op.mensagens.map((msg, mIdx) => (
                      <div key={mIdx} style={{
                        maxWidth: '95%',
                        background: '#dcf8c6',
                        color: '#222',
                        borderRadius: '16px 16px 4px 16px',
                        padding: '10px 16px',
                        marginBottom: '12px',
                        boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                        fontSize: 15,
                        alignSelf: 'flex-end',
                        border: '1px solid #b2e59e',
                        wordBreak: 'break-word',
                        position: 'relative',
                      }}>
                        {msg.tipo === 'texto' && (
                          <span dangerouslySetInnerHTML={{ __html: formatMessage(msg.conteudo) }} />
                        )}
                        {msg.tipo === 'config' && (
                          <span style={{ color: '#51a197', fontWeight: 'bold' }}>{msg.conteudo}</span>
                        )}
                        {msg.tipo === 'descricao' && (
                          <span>
                            <b>Descrição do grupo:</b><br />
                            <span style={{ whiteSpace: 'pre-line', display: 'block' }}>
                              {msg.conteudo}
                            </span>
                          </span>
                        )}
                        {msg.tipo === 'imagem' && (
                          <span>
                            <b>Imagem do grupo:</b><br />
                            <img src={msg.conteudo} alt="Imagem do grupo" style={{ maxWidth: 180, maxHeight: 180, borderRadius: '16px', marginTop: 8 }} />
                          </span>
                        )}
                        {msg.tipo === 'audio' && (
                          <audio controls src={msg.url || msg.conteudo} style={{ width: 220 }} />
                        )}
                        {/* Adicione outros tipos se necessário */}
                      </div>
                    ))
                  ) : (
                    <div style={{ color: '#888', fontStyle: 'italic' }}>
                      Nenhuma mensagem.
                      {op.status === 'Agendado' && op.etapaEnvio && (
                        <div style={{ marginTop: 8, color: '#005c53', fontWeight: 'bold' }}>
                          Etapa de envio: {op.etapaEnvio}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                {/* Lado direito: Informações adicionais */}
                  <div
                    style={{
                      flex: 1.5,
                      minWidth: 0,
                      padding: "32px 24px",
                      background: "#f9f9f9",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      gap: 24,
                      fontSize: 15,
                      color: "#222",
                      position: "relative"
                    }}
                  >
                  {/* Ícone pulsante laranja para agendado - lado direito */}
                  {op.status === 'Agendado' && (
                    <div style={{ position: 'absolute', top: 24, right: 24, zIndex: 10, display: 'flex', alignItems: 'center', gap: 10 }}>
                      {op.status === 'Agendado' && <PulsarIcon />}
                      {op.status === 'Enviado' && <FaCheckCircle color="#2ecc40" size={22} title="Enviado para os grupos" />}
                    </div>
                  )}
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <FaUser color="#51a197" size={22} title="Conta que enviou" />
                    <span>{op.contas && op.contas.length > 0 ? op.contas.map(c => c.nome).join(', ') : 'Nenhuma conta'}</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <FaBullhorn color="#51a197" size={22} title="Grupos" />
                    <span>
                      {op.grupos && op.grupos.length > 0
                        ? op.grupos.map((g, i) =>
                            g && typeof g === 'object' && g.nomeCampanha && g.nomeGrupo
                              ? (
                                  <span key={i}>
                                    <b>{g.nomeCampanha}</b> - {g.nomeGrupo}{' '}
                                  </span>
                                )
                              : (typeof g === 'string' ? g : '')
                          )
                        : 'Nenhum grupo'}
                    </span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <FaCalendarPlus color="#51a197" size={22} title="Data programada" />
                    <span>
                      {op.data ? `${op.data}${op.hora ? ' ' + op.hora : ''}` : '-'}
                    </span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <FaClock color="#51a197" size={22} title={op.status === 'Agendado' ? 'Hora agendada' : 'Hora de disparo'} />
                    <span>
                      {op.status === 'Agendado'
                        ? (op.hora ? op.hora : '-')
                        : (op.horaDisparo ? op.horaDisparo : '-')}
                    </span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <FaCheckCircle color="#2ecc40" size={22} title="Status" />
                    <span>{op.status}</span>
                  </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div style={{ color: '#888', fontStyle: 'italic', margin: '32px 0' }}>Nenhuma operação cadastrada.</div>
          )}
        </div>
      </>
    ),
    espera: <div>Automações em Espera.</div>,
    agendado: <div>Automações Agendadas.</div>,
    processo: <div>Automações em Processo.</div>,
    sucesso: <div>Automações com Sucesso.</div>,
    falhou: <div>Automações que Falharam.</div>,
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar Bootstrap 5 - por cima do header */}
      <nav
        className={`d-flex flex-column flex-shrink-0 text-white${window.innerWidth <= 768 && sidebarOpen ? ' menu-aberto' : ''}`}
        style={{
          width:
            window.innerWidth <= 768
              ? sidebarOpen
                ? "80vw"
                : 56
              : sidebarOpen
              ? 220
              : 70,
          maxWidth:
            window.innerWidth <= 768
              ? sidebarOpen
                ? 260
                : 56
              : sidebarOpen
              ? 220
              : 70,
          minWidth:
            window.innerWidth <= 768
              ? 56
              : sidebarOpen
              ? 220
              : 70,
          background: "#005c53",
          minHeight: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          zIndex: 3000, // sempre acima do conteúdo
          transition: "width 0.3s",
          alignItems: "center",
          boxShadow:
            window.innerWidth <= 768 && sidebarOpen
              ? "4px 0 16px rgba(0,0,0,0.18)"
              : "2px 0 8px rgba(0,0,0,0.10)",
          overflowX: "hidden",
          overflowY: "auto",
          scrollbarWidth: "thin",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: sidebarOpen ? "row" : "column",
            justifyContent: sidebarOpen ? "space-between" : "center",
            alignItems: "center",
            padding: sidebarOpen ? "16px 16px 8px 16px" : "24px 0 8px 0",
            transition: "all 0.3s",
            gap: sidebarOpen ? 12 : 8,
          }}
        >
          {sidebarOpen ? (

            <a href="/app">
              <img src={LogoCompleta} alt="Logo Completa" style={{ height: 40, transition: "all 0.3s" }} /></a>

          ) : (

            <a href="/app">
            <img src={LogoIcone} alt="Logo Ícone" style={{ height: 32, width: 32, transition: "all 0.3s" }} /></a>
          )}
          <button
            onClick={() => setSidebarOpen((open) => !open)}
            className="btn btn-link text-white"
            style={{
              fontSize: 24,
              textDecoration: "none",
              boxShadow: "none",
              marginLeft: sidebarOpen ? 12 : 0,
              marginRight: 0,
              padding: 0,
              alignSelf: "center",
            }}
            title={sidebarOpen ? "Fechar menu" : "Abrir menu"}
          >
            <i className={`bi ${sidebarOpen ? "bi-x-lg" : "bi-list"}`}></i>
          </button>
        </div>
        <ul className="nav nav-pills flex-column mb-auto w-100"
          style={{
            alignItems: sidebarOpen ? "flex-start" : "center",
            gap: sidebarOpen ? 0 : -12,
            paddingBottom: 0,
          }}>
          <li className="nav-item w-100">
            <a
              href="/app"
              className="nav-link d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
                background: "#51a197",
                color: "#fff",
                fontWeight: "bold",
                borderRadius: 8,
                transition: "background 0.3s",
              }}
            >
              <i className="bi bi-speedometer2" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Dashboard</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
          <li className="w-100">
            <a href="http://localhost:3000/Campanha" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-megaphone" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Campanhas</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
          <li className="w-100">
            <a href="http://localhost:3000/Projetos" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-folder2-open" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Meus Projetos</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
          <li className="w-100">
            <a href="http://localhost:3000/Contas" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-person-lines-fill" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Contas</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
          <li className="w-100">
            <a href="http://localhost:3000/Operacoes" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-gear" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Operações</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
          <li className="w-100">
            <a href="#" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-send" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Disparo 1x1</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
          <li className="w-100">
            <a href="#" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-robot" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Automações</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
        </ul>
      </nav>
      {/* Header fixo no topo, mas atrás do menu lateral */}
      <nav
        className="navbar navbar-expand-lg navbar-dark"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: HEADER_HEIGHT,
          background: "#005c53",
          zIndex: 1200,
          borderRadius: 0,
          marginLeft: 0,
        }}
      >
        <div style={{ marginLeft: sidebarOpen ? 220 : 70, transition: "margin-left 0.3s" }}>
          <span style={{ color: "#fff", fontWeight: "bold", fontSize: 20 }}>Operações</span>
        </div>
        <div className="ms-auto d-flex align-items-center pe-3">
          <div className="dropdown">
            <a
              href="#"
              className="nav-link d-flex align-items-center p-0"
              id="userDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style={{ color: "#fff", cursor: "pointer" }}
            >
              <i
                className="bi bi-person-circle"
                style={{
                  fontSize: 28,
                }}
              ></i>
              <span
                className="d-none d-lg-inline ms-2"
                style={{
                  padding: "6px 16px",
                  borderRadius: 16,
                  transition: "background 0.2s",
                  display: "inline-block",
                }}
              >
                Nome do Usuário
              </span>
            </a>
            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
              <li>
                <a className="dropdown-item" href="#">Perfil</a>
              </li>
              <li>
                <a className="dropdown-item" href="#">Configurações</a>
              </li>
              <li>
                <a className="dropdown-item" href="#">Sair</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      {/* Conteúdo da página de operações */}
      <div style={{
        position: "relative",
        zIndex: 1,
        marginLeft: window.innerWidth > 768 ? 70 : 56, // 56px para o menu lateral fechado no desktop/mobile
        paddingTop: HEADER_HEIGHT,
        width: window.innerWidth > 768
          ? "calc(100% - 70px)"
          : "calc(100vw - 56px)",
        transition: "margin-left 0.3s, padding-top 0.3s, width 0.3s",
        minHeight: "100vh",
        boxSizing: "border-box",
        overflowX: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center" // centraliza todo o conteúdo
      }}>
        {/* Botões de paginação e botão de adicionar */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "24px 0 24px 0",
            gap: 16,
            width: "100%",
            maxWidth: 900 // limita largura máxima para centralizar melhor
          }}
        >
          <div
            style={{
              display: "flex",
              gap: 12,
              flexWrap: "wrap",
              justifyContent: "center",
              width: "100%"
            }}
          >
            {TABS.map(tab => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                style={{
                  background: activeTab === tab.key ? "#51a197" : "#fff",
                  color: activeTab === tab.key ? "#fff" : "#005c53",
                  border: "1px solid #51a197",
                  borderRadius: 8,
                  padding: window.innerWidth <= 768 ? "10px 12px" : "8px 18px",
                  fontWeight: "bold",
                  fontSize: window.innerWidth <= 768 ? 14 : 15,
                  cursor: "pointer",
                  boxShadow: activeTab === tab.key ? "0 1px 4px rgba(0,0,0,0.07)" : "none",
                  transition: "all 0.2s",
                  width: window.innerWidth <= 480 ? "100%" : "auto"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              marginTop: 16
            }}
          >
            <button
              style={{
                background: "#51a197",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                padding: window.innerWidth <= 768 ? "12px 24px" : "8px 24px",
                fontWeight: "bold",
                fontSize: window.innerWidth <= 768 ? 16 : 16,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 8,
                boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
                width: window.innerWidth <= 480 ? "100%" : "auto"
              }}
              onClick={() => navigate('/Adicionaroperacao')}
            >
              <i className="bi bi-plus-circle" style={{ fontSize: 22 }}></i>
              Adicionar Operação
            </button>
          </div>
        </div>
        {/* Frame de conteúdo da aba selecionada */}
        <div style={{
          background: "#fff",
          borderRadius: 16,
          boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
          padding: 24,
          minHeight: 200,
          marginBottom: 32,
          width: "100%",
          maxWidth: 900 // centraliza e limita largura do conteúdo
        }}>
          {tabContent[activeTab]}
        </div>
        
          </div>
        </div>
      
  
  );
};

// Adicione este helper no topo do arquivo (ou em um util separado)
function formatMessage(text) {
  // Negrito WhatsApp: *texto*
  let formatted = text.replace(/\*(?!\*)([^\*\n]+)\*/g, '<b>$1</b>');
  // Negrito Markdown: **texto**
  formatted = formatted.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
  // Itálico WhatsApp: _texto_
  formatted = formatted.replace(/_(.*?)_/g, '<i>$1</i>');
  // Links: [texto](url)
  formatted = formatted.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank">$1</a>');
  // Emojis simples: :smile:
  formatted = formatted.replace(/:smile:/g, '😄');
  // Preserva quebras de linha como <br> para exibir parágrafos
  formatted = formatted.replace(/\n/g, '<br>');
  return formatted;
}

export default Operacoes;